import api from "./api";

export const getStatements = async () =>
    api({
        url: '/user_statements',
        method: 'get',
    });